import React from "react";
import { Link } from "react-router-dom";
import { works } from "../utils/data";

function Work() {
  return (
    <div className="container my-5">
      <div className="d-flex flex-column align-items-center justify-content-center">
        {/* Section Header */}
        <div className="mt-5 mb-5 text-center">
          <h2 className="m-0">
            M<span className="border-reddish pb-1">y Wor</span>k
          </h2>
        </div>

        {/* Work Cards */}
        {works.map((work, index) => (
          <div
            key={work.id}
            className="card round-x1 shad-x1 border-0 mb-5"
            style={{
              maxWidth: "900px",
              width: "100%",
              overflow: "hidden",
              zIndex: 1000,
            }}
          >
            <div className="row g-0 h-100">
              {/* Image Section */}
              <div
                className={`col-md-6 p-0 m-0 ${
                  index % 2 === 0 ? "order-md-2" : "order-md-1"
                }`}
              >
                <img
                  src={work.image}
                  className="img-fluid"
                  alt={work.title}
                  width="100%"
                  height="100%"
                />
              </div>

              {/* Content Section */}
              <div
                className={`col-md-6 d-flex align-items-center justify-content-center ${
                  index % 2 === 0 ? "order-md-1" : "order-md-2"
                }`}
              >
                <div className="card-body w-100">
                  <h5 className="card-title">{work.title}</h5>
                  <p className="card-text text-muted">{work.description}</p>
                  <Link to={`/work/${work.id}`}>
                    <button
                      type="button"
                      className="bg-white"
                      style={{
                        width: "50%",
                        border: "2px solid black",
                        background: "white",
                        color: "black",
                        borderRadius: "50px",
                        height: "50px",
                      }}
                    >
                      View Project
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Work;

// import React from "react";

// function Work() {
//   const works = [
//     {
//       id: 1,
//       title: "Chill pill",
//       description: "Medication reminder for social good",
//       image: "/image/work1.png",
//       alt: "Chill pill project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/02ec50f3",
//     },
//     {
//       id: 2,
//       title: "The CHI App",
//       description: "Voice assistant app",
//       image: "/image/work2.png",
//       alt: "CHI App project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/025506e1",
//     },
//     {
//       id: 3,
//       title: "Dollar Bank",
//       description: "Banking website",
//       image: "/image/work3.png",
//       alt: "Dollar Bank project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/026e282a",
//     },
//   ];

//   return (
//     <div className="container my-5">
//       {/* Section Heading */}
//       <div className="text-center my-5">
//         <h2 className="m-0">
//           M
//           <span className="border-reddish pb-1">
//             y Wor
//           </span>
//           k
//         </h2>
//       </div>
//       {/* Cards Grid */}
//       <div className="row g-4">
//         {works.map((work) => (
//           <div key={work.id} className="col-12 col-md-6">
//             <div className="card h-100">
//               <div className="row g-0 h-100">
//                 {/* Image */}
//                 <div className="col-12 col-md-6 order-1 order-md-2">
//                   <img
//                     src={work.image}
//                     className="img-fluid rounded h-100 w-100"
//                     alt={work.alt}
//                     style={{ objectFit: "cover" }}
//                   />
//                 </div>
//                 {/* Content */}
//                 <div className="col-12 col-md-6 d-flex align-items-center order-2 order-md-1">
//                   <div className="card-body">
//                     <h5 className="card-title">{work.title}</h5>
//                     <p className="card-text text-muted small">
//                       {work.description}
//                     </p>
//                     <a
//                       href={work.url}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="btn border border-dark rounded-pill px-3 py-1"
//                     >
//                       View Project
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Work;

// import React from "react";

// function Work() {
//   const works = [
//     {
//       id: 1,
//       title: "Chill pill",
//       description: "Medication reminder for social good",
//       image: "/image/work1.png",
//       alt: "Chill pill project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/02ec50f3",
//     },
//     {
//       id: 2,
//       title: "The CHI App",
//       description: "Voice assistant app",
//       image: "/image/work2.png",
//       alt: "CHI App project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/025506e1",
//     },
//     {
//       id: 3,
//       title: "Dollar Bank",
//       description: "Banking website",
//       image: "/image/work3.png",
//       alt: "Dollar Bank project",
//       url: "https://uxfol.io/p/chinazaeskayportfolio/026e282a",
//     },
//   ];

//   return (
//     <div className="container my-5">
//       {/* Section Heading */}
//       <div className="text-center my-5">
//         <h2 className="m-0">
//           M
//           <span className="border-reddish pb-1">
//             y Wor
//           </span>
//           k
//         </h2>
//       </div>
//       {/* Inline Cards */}
//       <div className="d-flex flex-nowrap overflow-auto gap-3">
//         {works.map((work) => (
//           <div key={work.id} className="card" style={{ minWidth: "300px" }}>
//             <img
//               src={work.image}
//               className="card-img-top"
//               alt={work.alt}
//               style={{ objectFit: "cover", height: "200px" }}
//             />
//             <div className="card-body">
//               <h5 className="card-title">{work.title}</h5>
//               <p className="card-text text-muted small">{work.description}</p>
//               <a
//                 href={work.url}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn border border-dark rounded-pill px-3 py-1"
//               >
//                 View Project
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Work;
